import { AmazonIcon, ArrowNarrowRightIcon, VizitLogoMark } from '@vizit/icons';
import { cx } from '@vizit/theme';

interface AmazonToVizitRowProps {
  className?: string;
}

function AmazonToVizitRow(props: AmazonToVizitRowProps) {
  const { className } = props;

  return (
    <div aria-hidden="true" className={cx('flex items-center justify-center gap-8 py-4', className)}>
      <div className="h-20 w-20 rounded-md border border-secondary shadow-xs flex items-center justify-center bg-primary">
        <AmazonIcon width={22} height={20} />
      </div>
      <ArrowNarrowRightIcon width={20} className="text-quaternary mx-18" />
      <div className="h-20 w-20 rounded-md border border-secondary shadow-xs flex items-center justify-center bg-blue-500">
        <VizitLogoMark color="white" width={18} height={20} />
      </div>
    </div>
  );
}

export { AmazonToVizitRow };
export type { AmazonToVizitRowProps };
